import { Link } from "react-router-dom";
import { useState } from "react";
import Toast from "./Toast";

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const [showToast, setShowToast] = useState(false);

  const handleCareersClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setShowToast(true);
  };
  
  return (
    <footer className="bg-linear-to-r from-sky-700 to-blue-600 text-white mt-16">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          
          {/* Company Info */}
          <div className="md:col-span-1">
            <div className="flex items-center space-x-2 mb-4">
              <img 
                src="/zero-harm-ai-logo.png" 
                alt="Zero Harm AI logo" 
                className="h-6 w-auto object-contain"
              />
              <span className="text-xl font-bold">Zero Harm AI</span>
            </div>
            <p className="text-sm text-blue-50 mb-4">
              Agentic AI and AI security development for production environments.
            </p>
            <p className="text-xs text-blue-100 mb-4">
              Creator of the ZeroHarmAI open-source security toolkit.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://linkedin.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-blue-50 hover:text-white transition"
                aria-label="LinkedIn"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                </svg>
              </a>
              <a 
                href="https://github.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-blue-50 hover:text-white transition"
                aria-label="GitHub"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                </svg>
              </a>
              <a 
                href="https://twitter.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-blue-50 hover:text-white transition"
                aria-label="Twitter"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                </svg>
              </a>
            </div>
          </div>
          
          {/* Services */}
          <div>
            <h3 className="font-bold text-lg mb-4">Services</h3>
            <ul className="space-y-2 text-sm text-blue-50">
              <li><Link to="/contact" className="hover:text-white transition">AI Agent Development</Link></li>
              <li><Link to="/contact" className="hover:text-white transition">MCP &amp; Tool Integration</Link></li>
              <li><Link to="/contact" className="hover:text-white transition">AI Security Development</Link></li>
              <li><Link to="/contact" className="hover:text-white transition">Agent Security Assessment</Link></li>
              <li><Link to="/contact" className="hover:text-white transition">Secure Agent Operations</Link></li>
            </ul>
          </div>
          
          {/* Company */}
          <div>
            <h3 className="font-bold text-lg mb-4">Company</h3>
            <ul className="space-y-2 text-sm text-blue-50">
              <li><Link to="/about" className="hover:text-white transition">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-white transition">Contact</Link></li>
              <li>
                <button 
                  onClick={handleCareersClick}
                  className="hover:text-white transition text-left"
                >
                  Careers
                </button>
              </li>
            </ul>
          </div>
          
          {/* Contact */}
          <div>
            <h3 className="font-bold text-lg mb-4">Get in Touch</h3>
            <ul className="space-y-2 text-sm text-blue-50">
              <li>
                <a href="mailto:info@zeroharmai.com" className="hover:text-white transition flex items-center gap-2">
                  <span>📧</span> info@zeroharmai.com
                </a>
              </li>
              <li className="flex items-center gap-2">
                <span>📍</span> Portland, Oregon
              </li>
              <li className="flex items-center gap-2">
                <span>🕐</span> Mon-Fri, 9AM-5PM PST
              </li>
            </ul>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="border-t border-blue-300 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-blue-50">
          <p>© {currentYear} Zero Harm AI. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-white transition">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white transition">Terms of Service</Link>
          </div>
        </div>
      </div>

      {/* Toast Notification */}
      {showToast && (
        <Toast
          type="success"
          message="No openings at this time"
          onClose={() => setShowToast(false)}
        />
      )}
    </footer>
  );
}
